var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrapper" }, [
      _c("img", {
        staticClass: "image",
        attrs: { src: "static/img/ship.avif" }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "blockA" }, [
        _vm._v(
          "\n        LD power automation is dedicated to providing reliable shore connection (cold ironing) services for the maritime industry.\n        "
        ),
        _c("br"),
        _vm._v(
          "We specialize in ensuring vessels can seamlessly and safely connect to shore power, reducing emissions, improving efficiency, and supporting environmental compliance.\n        "
        ),
        _c("br"),
        _vm._v(
          "Our experienced engineers handle every stage of the process — from installation and commissioning to troubleshooting and maintenance — guaranteeing professional and timely delivery. With extensive expertise across international standards and port requirements, we make sure your operations run without interruption.\n        "
        ),
        _c("br"),
        _vm._v(
          "We are committed to building strong, long-term relationships with our clients, based on trust, technical excellence, and a deep understanding of their needs in shore power connection.\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2197ae22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2197ae22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HomeDefault.vue
// module id = 458
// module chunks = 0